import styleInject from 'style-inject';

var css_248z = ".FixedSidebar-module_container__K2KKN{flex:0 0 210px}@media (max-width:768px){.FixedSidebar-module_container__K2KKN{flex:0}}";
var styles = {"container":"FixedSidebar-module_container__K2KKN"};
styleInject(css_248z);

export { styles as default };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRml4ZWRTaWRlYmFyLm1vZHVsZS5zY3NzLmpzIiwic291cmNlcyI6W10sInNvdXJjZXNDb250ZW50IjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7In0=
